import React, { useEffect } from 'react';
import { Box, Grid, Stack, TextField, Typography } from '@mui/material'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { dailyRevenueGraphAction } from '../../redux/toolkit/dashboard/dailyRevenueGraph';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  
  export const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' 
      },
      
    },
  };

  const p_Properties = {
    fontWeight: "500",
    paddingBlock: "10px",
    fontSize: "16px",
    display: "flex",
    color: "rgba(47, 52, 62, 1)",
  };

const DailyRevenueChart = () => {
    const dispatch = useDispatch()
    const dailyRevenue = useSelector(state => state.dailyRevenueGraph)
    const labels = [];
    const userCount = [];


    dailyRevenue?.data.map(item => {
        labels.push(item?._id)
        userCount.push(item?.total_points)
    })

    const [date, setDate] = React.useState(dayjs());

    const onDateChangeHandler = (date) => {
        setDate(date)
    };

    const submitHandler = (e) => {

        const startDate = new Date(date.$d)
        startDate.setHours(startDate.getHours() + 5);
        startDate.setMinutes(startDate.getMinutes() + 30);
        const newValue = startDate.toISOString()
        const query = {}
        query.date = newValue;
        query.days = e.target.value
        dispatch(dailyRevenueGraphAction())
    }

    const data = {
        labels,
        datasets: [
            {
                label: 'Revenue',
                data: userCount,
                // borderColor: '#0C6A96',
                backgroundColor: 'rgba(138, 180, 117, 1)',
                tension: 0.4,

            },

        ],
    };

    useEffect(() => {

        const startDate = new Date(date.$d)
        startDate.setHours(startDate.getHours() + 5);
        startDate.setMinutes(startDate.getMinutes() + 30);
        const newValue = startDate.toISOString()
        const query = {}
        query.date = newValue;
        query.days = 7;
        dispatch(dailyRevenueGraphAction())
    }, [dispatch])
    return (
        <Stack flexDirection={"row"}>
            <Grid item xs={12}>
            <Typography sx={p_Properties} variant="p">
                Daily Revenue
              </Typography>
              <Box sx={{
                width:"100%",
                height:"1px",
                background:"rgba(217, 217, 217, 1)"


              }}/>
              <br></br>
              <br/>
                <Bar options={options} data={data} /></Grid>
            
        </Stack>


    );
}

export default DailyRevenueChart
